import { render, staticRenderFns } from "./MapStackedItems.vue?vue&type=template&id=816fa090&scoped=true"
import script from "./MapStackedItems.vue?vue&type=script&lang=ts"
export * from "./MapStackedItems.vue?vue&type=script&lang=ts"
import style0 from "./MapStackedItems.vue?vue&type=style&index=0&id=816fa090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816fa090",
  null
  
)

export default component.exports